<load-spinner
  [show]=this.showSpinner
></load-spinner>

<div id="clientConfigForm" class="row mt-2" [ngClass]="{'disabled': aviClientId==null}" style="max-width: 700px;">
  <div id="availableFields"  class="col">
    <div class="card">
      <div class="card-header">
        Available Fields 
      </div>
      
      <ul class="list-group list-group-flush">
          <li [ngClass]="{'active': item.selected}" (click)="item.selected = !item.selected" class="list-group-item" *ngFor="let item of clientConfigFields.available">
            <span title="{{item.itemName}}">{{item.itemName}}</span>
            <i class="arrow-down float-right"(click)="onAvailableChangePosition(item, false, false, $event)"></i>
            <i class="arrow-up float-right mr-1" (click)="onAvailableChangePosition(item, true, false, $event)"></i>
          </li>
      </ul>
    </div>
    <button (click)="onSelectAllAvailable(true)" class="p-0 btn btn-link">Select all</button> / <button (click)="onSelectAllAvailable(false)" class="p-0 btn btn-link">Deselect all</button>
  </div>

  <div class="col flex-grow-0">
      <button id="addActiveButton" (click)="onAddToActive()" class="mt-3 pt-2 btn btn-primary"> > </button>
      <br/>
      <button id="addAvailableButton" (click)="onAddToAvailable()" class="mt-3 pt-2 btn btn-primary"> < </button>
  </div>

  <div id="activeFields" class="col">
    <div class="card" [ngClass]="{'show-default-message': showDefaultConfigMessage}">
      <div class="card-header">
        Active Fields
      </div>
      <ul class="list-group list-group-flush " no-config-note="Reminder: no saved config exists - backups for this client are using default fields.">
          <li [ngClass]="{'active': item.selected}" (click)="item.selected = !item.selected" class="list-group-item" *ngFor="let item of clientConfigFields.active">
            <span title="{{item.itemName}}">{{item.itemName}}</span>
            <i class="arrow-down float-right"(click)="onActiveChangePosition(item, false, false, $event)"></i>
            <i class="arrow-up float-right mr-1" (click)="onActiveChangePosition(item, true, false, $event)"></i>
          </li>
      </ul>
    </div>
    <button (click)="onSelectAllActive(true)" class="p-0 btn btn-link">Select all</button> / <button (click)="onSelectAllActive(false)" class="p-0 btn btn-link">Deselect all</button>
  </div>
</div>

<div class="row" [ngClass]="{'disabled': aviClientId==null}">
  <div class="col-lg-12">
    <button id="submitButton" class="mt-3 btn btn-primary" (click)="onSubmit()">Submit</button>
  </div>
</div>